import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const UnarchiveDimensionValueModal = ({uiState, modalOpen}) => {
  return (
    <Modal
      title='time_tracking.dimensions.unarchive.Unarchive Value'
      size='sm'
      isOpen={modalOpen}
      onHide={() => uiState.closeUnarchiveDimensionValueModal()}
    >
      <div className='mb3 jumbo'>
        <FormattedMessage id={'time_tracking.dimensions.unarchive.DESCRIPTION'}/>
      </div>
      <ModalButtons
        saveCaption='time_tracking.dimensions.unarchive.Unarchive'
        onSave={() => uiState.unarchiveDimensionValue()}
        onCancel={() => uiState.closeUnarchiveDimensionValueModal()}/>
    </Modal>
  );
};

export default UnarchiveDimensionValueModal;
